import React, {Component} from 'react';
import {connect} from 'react-redux';
class Dashboard extends Component {
  render() {
    return <div>
      <div className="row" style={{margin: '0px 15px'}}>
        <div className="col-md-6">
          <div className="panel panel-default">
            <div className="panel-heading">
              <h3 className="panel-title">Active perks</h3>
            </div>
            <div className="panel-body">
              <table className="table table-condensed table-hover">
                <thead>
                <tr>
                  <th className="bold">#</th>
                  <th className="bold">Name</th>
                  <th className="bold">Referrals Generated</th>
                </tr>
                </thead>
              </table>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="panel panel-default">
            <div className="panel-heading">
              <h3 className="panel-title">Totals</h3>
            </div>
            <div className="panel-body">
              <ul className="list-total">
                <li>QR Code Scans: 0</li>
                <li>Referrals Sent: 0</li>
                <li>Incentives Redeemed: 0</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

export default connect(
  state => ({}),
  dispatch => ({})
)(Dashboard);



/** WEBPACK FOOTER **
 ** ./src/components/Dashboard/index.js
 **/